export enum StirbtBeiAnwendung {
  STIRBT_NICHT = "STIRBT_NICHT",
  STIRBT_FALLS_FRAKTION = "STIRBT_FALLS_FRAKTION",
  STIRBT_FALLS_KARTE = "STIRBT_FALLS_KARTE",
  STIRBT_IMMER = "STIRBT_IMMER",
}
